/**
 * Client-side guards before any future API calls. Does not replace server validation.
 * (XSS: React text nodes escape by default; keep avoiding dangerouslySetInnerHTML.)
 */

const EMAIL_MAX_LENGTH = 254;

function hasAsciiControlChars(s) {
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c <= 0x1f || c === 0x7f) {
      return true;
    }
  }
  return false;
}

export function normalizeEmail(raw) {
  if (raw == null || typeof raw !== "string") {
    return "";
  }
  return raw.trim().slice(0, EMAIL_MAX_LENGTH);
}

export function isPlausibleEmail(email) {
  if (!email || email.length > EMAIL_MAX_LENGTH) {
    return false;
  }
  if (hasAsciiControlChars(email)) {
    return false;
  }
  // Practical HTML5-style check; server should still validate.
  const re =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return re.test(email);
}
